import * as React from 'react'
import { FormSelect } from '@hyper/forms/form-select'
import { Row } from 'reactstrap'
import { useHandleTableFiltersChange } from '@components/table/use-handle-table-filters-change'
import { FormProvider, useForm } from 'react-hook-form'
import { SubmitFilter } from '@modules/reception/common/filters/submit-filter'
import { CustomReactSelectOption } from '@components/custom-react-select'
import { ColAuto } from '@hyper/col-auto'
import { useModal } from '@components/modals/use-modal'
import { ClientDetails } from '@models/clients'
import { ClientDetailsModalGastroCardFilters } from '@modules/crm/clients/details-modal/gastro-cards/gastro-cards'

interface Props {
  filters: ClientDetailsModalGastroCardFilters
  defaultFilters: ClientDetailsModalGastroCardFilters
  onFiltersChange: (filters: ClientDetailsModalGastroCardFilters) => void
  gastroCardStatusOptions: CustomReactSelectOption[]
  client: ClientDetails
  onClientRefresh: () => void
}

export const ClientDetailsModalGastroCardsTableFilters = ({
  filters,
  defaultFilters,
  onFiltersChange,
  gastroCardStatusOptions,
  onClientRefresh,
  client,
}: Props): JSX.Element => {
  const methods = useForm<ClientDetailsModalGastroCardFilters>({
    defaultValues: filters,
  })

  const handleReset = () => {
    methods.reset()
    onFiltersChange(defaultFilters)
  }

  useHandleTableFiltersChange(methods.watch, filters, onFiltersChange)

  const [showAddGastroCardModal] = useModal('GastroCardDialog', {
    gastroCardClient: client,
    refresh: onClientRefresh,
    kind: 'normal',
  })

  return (
    <FormProvider {...methods}>
      <Row>
        <FormSelect
          options={gastroCardStatusOptions}
          name="statuses"
          label="Status"
          selectProps={{ isSelectMulti: true, isClearable: true }}
          formPlainProps={{ colSize: 4 }}
        />

        <SubmitFilter handleReset={handleReset} />
        <ColAuto className="ml-auto col-auto mb-2 align-self-end">
          <button type="button" className="btn btn btn-outline-secondary" onClick={showAddGastroCardModal}>
            <i className="uil-plus mr-1" />
            Dodaj nowy voucher
          </button>
        </ColAuto>
      </Row>
    </FormProvider>
  )
}
